import React from "react";

const HappyFaceIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      id="happy_face_icon"
      data-name="happy face"
      {...props}
      width={props.width || "16"}
      height={props.height || "16"}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.9987 1.33334C4.3227 1.33334 1.33203 4.32401 1.33203 8.00001C1.33203 11.676 4.3227 14.6667 7.9987 14.6667C11.6747 14.6667 14.6654 11.676 14.6654 8.00001C14.6654 4.32401 11.6747 1.33334 7.9987 1.33334ZM7.9987 13.3333C5.05803 13.3333 2.66536 10.9407 2.66536 8.00001C2.66536 5.05934 5.05803 2.66668 7.9987 2.66668C10.9394 2.66668 13.332 5.05934 13.332 8.00001C13.332 10.9407 10.9394 13.3333 7.9987 13.3333Z"
        fill={props.fill || "#296C50"}
      />
      <path
        d="M5.66797 8C6.22025 8 6.66797 7.55228 6.66797 7C6.66797 6.44772 6.22025 6 5.66797 6C5.11568 6 4.66797 6.44772 4.66797 7C4.66797 7.55228 5.11568 8 5.66797 8Z"
        fill={props.fill || "#296C50"}
      />
      <path
        d="M10.3274 7.99067C10.8771 7.99067 11.3227 7.54504 11.3227 6.99533C11.3227 6.44563 10.8771 6 10.3274 6C9.77766 6 9.33203 6.44563 9.33203 6.99533C9.33203 7.54504 9.77766 7.99067 10.3274 7.99067Z"
        fill={props.fill || "#296C50"}
      />
      <path
        d="M8.0013 12C10.668 12 11.3346 9.33334 11.3346 9.33334H4.66797C4.66797 9.33334 5.33464 12 8.0013 12Z"
        fill={props.fill || "#296C50"}
      />
    </svg>
  );
};

export default HappyFaceIcon;
